import { Icon } from 'cdui-js';
import i18n from '../../../i18n';
import { BankShell } from './Shell';
import { finishToList } from './shared';
import './bank.css';

export const BankAccountSuccess = () => {
  return (
    <BankShell
      title={i18n.BankAccount.AddBank}
      backFn={finishToList}
      footer={
        <button type="button" class="btn-primary" onclick={finishToList}>
          {i18n.FundH5.Done}
        </button>
      }
    >
      <div class="success-body">
        <Icon name="common-result-success" class="success-result-icon" />
        <div class="success-title">{i18n.FundH5.SubmitSuccess}</div>
        <div class="success-desc">{i18n.BankList.SuccessDesc}</div>
      </div>
    </BankShell>
  );
};
